/** Exact rupee amounts stay in data; these helpers are display-only. */

const inr = new Intl.NumberFormat("en-IN");

export function formatCurrency(n, { signed = false } = {}) {
  const abs = Math.abs(n);
  const body = `₹${inr.format(Math.round(abs))}`;
  if (!signed) return n < 0 ? `(${body})` : body;
  if (n < 0) return `−${body}`;
  if (n > 0) return `+${body}`;
  return body;
}

export function formatLakhs(n, { digits = 2, signed = false } = {}) {
  const value = n / 100000;
  const abs = Math.abs(value).toFixed(digits);
  const body = `₹${abs}L`;
  if (!signed) return value < 0 ? `(${body})` : body;
  if (value < 0) return `−${body}`;
  if (value > 0) return `+${body}`;
  return body;
}

export function formatCrores(n, { digits = 2, signed = false } = {}) {
  const value = n / 10000000;
  const abs = Math.abs(value).toFixed(digits);
  const body = `₹${abs}Cr`;
  if (!signed) return value < 0 ? `(${body})` : body;
  if (value < 0) return `−${body}`;
  if (value > 0) return `+${body}`;
  return body;
}

/** Prefer crore from ₹1 crore upward, otherwise lakh. */
export function formatCompact(n, options = {}) {
  return Math.abs(n) >= 10000000 ? formatCrores(n, options) : formatLakhs(n, options);
}

export function formatPercentage(part, whole, digits = 1) {
  if (!whole) return "0%";
  return `${((part / whole) * 100).toFixed(digits)}%`;
}
